module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/brand/chat-bubble-brand-88b41c562465802dce4ff944ad714285.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/brand/chat-bubble-brand.svg
// module id = AUL6
// module chunks = 24